import api from './api';

/** Shared admin request options — never set Content-Type on FormData. */
export const adminHeaders = { headers: { 'X-Admin': '1' } };

export const authApi = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  me: () => api.get('/auth/me'),
  adminLogin: (data) => api.post('/auth/admin/login', data),
  adminMe: () => api.get('/auth/admin/me', adminHeaders),
};

export const productApi = {
  list: (params) => api.get('/products', { params }),
  facets: () => api.get('/products/facets'),
  get: (id) => api.get(`/products/${id}`),
  adminAll: () => api.get('/products/admin/all', adminHeaders),
  create: (formData) => api.post('/products', formData, adminHeaders),
  update: (id, formData) => api.put(`/products/${id}`, formData, adminHeaders),
  deactivate: (id) => api.patch(`/products/${id}/deactivate`, {}, adminHeaders),
  activate: (id) => api.patch(`/products/${id}/activate`, {}, adminHeaders),
  remove: (id) => api.delete(`/products/${id}`, adminHeaders),
};

export const categoryApi = {
  list: (params) => api.get('/categories', { params }),
  uniqueSubs: () => api.get('/categories/sub/unique'),
  create: (formData) => api.post('/categories', formData, adminHeaders),
  update: (id, formData) => api.put(`/categories/${id}`, formData, adminHeaders),
  remove: (id) => api.delete(`/categories/${id}`, adminHeaders),
};

export const labelApi = {
  list: () => api.get('/labels'),
  create: (formData) => api.post('/labels', formData, adminHeaders),
  update: (id, formData) => api.put(`/labels/${id}`, formData, adminHeaders),
  remove: (id) => api.delete(`/labels/${id}`, adminHeaders),
};

export const sizeChartApi = {
  list: () => api.get('/size-charts'),
  default: () => api.get('/size-charts/default'),
  create: (data) => api.post('/size-charts', data, adminHeaders),
  update: (id, data) => api.put(`/size-charts/${id}`, data, adminHeaders),
  remove: (id) => api.delete(`/size-charts/${id}`, adminHeaders),
};

export const bannerApi = {
  list: () => api.get('/banners'),
  adminAll: () => api.get('/banners/admin/all', adminHeaders),
  create: (formData) => api.post('/banners', formData, adminHeaders),
  update: (id, formData) => api.put(`/banners/${id}`, formData, adminHeaders),
  remove: (id) => api.delete(`/banners/${id}`, adminHeaders),
};

export const testimonialApi = {
  list: () => api.get('/testimonials'),
  adminAll: () => api.get('/testimonials/admin/all', adminHeaders),
  create: (formData) => api.post('/testimonials', formData, adminHeaders),
  update: (id, formData) => api.put(`/testimonials/${id}`, formData, adminHeaders),
  remove: (id) => api.delete(`/testimonials/${id}`, adminHeaders),
};

export const cartApi = {
  get: () => api.get('/cart'),
  add: (data) => api.post('/cart/add', data),
  update: (data) => api.put('/cart/update', data),
  remove: (data) => api.delete('/cart/remove', { data }),
  sync: (items) => api.post('/cart/sync', { items }),
};

export const wishlistApi = {
  get: () => api.get('/wishlist'),
  add: (productId) => api.post('/wishlist/add', { productId }),
  remove: (productId) => api.delete('/wishlist/remove', { data: { productId } }),
  sync: (productIds) => api.post('/wishlist/sync', { productIds }),
};

export const contactApi = {
  submit: (data) => api.post('/contact', data),
  list: () => api.get('/contact', adminHeaders),
};

export const settingsApi = {
  get: () => api.get('/settings'),
  update: (formData) => api.put('/settings', formData, adminHeaders),
};
